import React from "react";
import {
  CLINIC_PHONE_DISPLAY,
  CLINIC_PHONE_TEL,
  CLINIC_EMAIL,
} from "../lib/whatsapp";

const SECTIONS = [
  {
    title: "Quick Links",
    links: [
      { label: "Services", href: "#services" },
      { label: "About", href: "#about" },
      { label: "Booking", href: "#booking" },
      { label: "Contact", href: "#contact" },
    ],
  },
  {
    title: "Treatments",
    links: [
      { label: "Back Pain", href: "#services" },
      { label: "Sciatica", href: "#services" },
      { label: "Knee Pain", href: "#services" },
      { label: "Paralysis Rehab", href: "#services" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", href: "#" },
      { label: "Terms of Service", href: "#" },
    ],
  },
];

export const Footer = () => {
  const scrollTo = (e, href) => {
    if (href.startsWith("#") && href !== "#") {
      e.preventDefault();
      document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer data-testid="site-footer" className="bg-slate-950 text-slate-300 pt-20 sm:pt-24 pb-10">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <div className="bg-white/95 rounded-2xl px-4 py-2">
                <img
                  src="/logo.png"
                  alt="Neuro Rehabs"
                  className="h-10 sm:h-12 w-auto object-contain"
                />
              </div>
            </div>
            <p className="mt-5 text-slate-400 leading-relaxed max-w-md">
              Premium home-visit physiotherapy by Dr. Gaurav Kumar PT — for pain
              relief, rehab and lasting recovery.
            </p>
            <div className="mt-6 space-y-2 text-sm">
              <p>
                <span className="text-slate-500">Phone:</span>{" "}
                <a className="text-white hover:text-brand-400" href={`tel:${CLINIC_PHONE_TEL}`}>
                  {CLINIC_PHONE_DISPLAY}
                </a>
              </p>
              <p>
                <span className="text-slate-500">Email:</span>{" "}
                <a className="text-white hover:text-brand-400 break-all" href={`mailto:${CLINIC_EMAIL}`}>
                  {CLINIC_EMAIL}
                </a>
              </p>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {SECTIONS.map((s) => (
              <div key={s.title}>
                <h4 className="text-xs font-semibold tracking-[0.18em] uppercase text-slate-500">
                  {s.title}
                </h4>
                <ul className="mt-4 space-y-3">
                  {s.links.map((l) => (
                    <li key={l.label}>
                      <a
                        href={l.href}
                        onClick={(e) => scrollTo(e, l.href)}
                        className="text-slate-300 hover:text-white text-sm transition-colors"
                      >
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">
            © 2026 Neuro Rehabs. All rights reserved.
          </p>
          <p className="text-xs text-slate-600">
            Crafted with care · Dr. Gaurav Kumar PT
          </p>
        </div>
      </div>
    </footer>
  );
};
